var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#103F68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98875 2.82251L14.3438 5.9067V12.0942L8.99494 15.1874L8.95162 15.1767L3.65625 12.0942V5.9067L8.95162 2.82251H8.98875ZM8.97131 3.46263L4.21875 6.23013V11.7708L8.97075 14.5377L9.55125 14.2019L13.7812 11.7691V6.23126L9.55125 3.78438L8.97131 3.46263ZM4.95506 9.43076L6.36188 8.37888L7.60556 9.17314V10.6019L8.54663 11.5086L8.54606 11.9339L7.63931 12.7833H6.87375L4.95563 9.43076H4.95506ZM9.4005 11.935L9.39881 11.5075L10.3365 10.6019V9.17314L11.5667 8.36876L12.9707 9.43132L11.0621 12.7737H10.3061L9.4005 11.935ZM8.06738 9.17314L7.6095 7.97445H10.3309L9.882 9.17314L10.0148 10.513L8.96456 10.5153L7.92675 10.5169L8.06738 9.17314ZM8.96456 7.64595L6.37819 7.64482L6.85913 5.49607H11.0576L11.5639 7.64763L8.96456 7.64595Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMco);
export default __webpack_public_path__ + "static/media/mco.e75d2df114986d7128b329badac2af96.svg";
export { ForwardRef as ReactComponent };